import React, { useState, useEffect } from 'react';
import { audioManager } from '../utils/audioManager';

export const SoundToggle: React.FC = () => {
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {
    // Cargar preferencia de sonido desde localStorage
    const savedMuteState = localStorage.getItem('gato-retro-muted') === 'true';
    setIsMuted(savedMuteState);
  }, []);

  const toggleSound = () => {
    const newMuteState = !isMuted;
    setIsMuted(newMuteState);
    localStorage.setItem('gato-retro-muted', newMuteState.toString());
    
    // Reproducir sonido de prueba si se activa el sonido
    if (!newMuteState) {
      audioManager.playSound('click');
    }
  };

  return (
    <button
      onClick={toggleSound}
      className="
        fixed top-3 right-3 sm:top-4 sm:right-4 z-50
        p-2 sm:p-3 bg-retro-dark/80 border-2 
        rounded-lg transition-all duration-300
        hover:scale-110 active:scale-95
      "
      style={{
        borderColor: isMuted ? '#666' : '#00ffff',
        boxShadow: isMuted ? 'none' : '0 0 10px #00ffff'
      }}
    >
      <span className="text-xl sm:text-2xl select-none">
        {isMuted ? '🔇' : '🔊'}
      </span>
    </button>
  );
};
